var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99309 18C10.2558 18.0022 10.5088 17.9012 10.6977 17.7187L15.7067 12.7085C15.8945 12.5205 16 12.2657 16 12C16 11.7343 15.8945 11.4795 15.7067 11.2915L10.6977 6.28129C10.5088 6.09876 10.2558 5.99775 9.99308 6.00004C9.73042 6.00232 9.47916 6.10771 9.29342 6.2935C9.10768 6.47928 9.00232 6.73061 9.00004 6.99335C8.99775 7.25608 9.09873 7.5092 9.28121 7.69819L13.5819 12L12.5801 13.0021L9.28121 16.3018C9.09873 16.4908 8.99776 16.7439 9.00004 17.0067C9.00232 17.2694 9.10768 17.5207 9.29342 17.7065C9.47916 17.8923 9.73042 17.9977 9.99309 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSm);
export default __webpack_public_path__ + "static/media/right-sm.4cf222caddc79b4571e96cbe4d4eec34.svg";
export { ForwardRef as ReactComponent };